import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity1 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_1;
}

export default CobbledRoadTileEntity1;
